import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  formLabel: {
    paddingTop: '16px',
    fontWeight: 600
  },
  formControl: {
    gap: 2
  },
  formContent: {
    gap: 2,
    display: 'grid'
  }
});
